// 시안 F 보드 공통 조각 — 업무 칸반(TaskPmKanban)과 홈 «내 업무» 보드(MainPage)가 같이 쓴다.

// 시안 F .board-column nth-child(1~4) — 상태 의미가 아니라 열 순서. 5번째부터 다시 처음.
export const BOARD_TONES = ['var(--gw-board-purple, #fcf9fd)', 'var(--gw-board-yellow, #fcfaf5)', 'var(--gw-board-blue, #f6fafd)', 'var(--gw-board-green, #f7faf7)'];
// 열 머리 알약 톤(시안 `pill ${color}`) — 같은 열 순서. 값은 uiStyles TONES 의 키다.
export const BOARD_PILL = ['purple', 'yellow', 'blue', 'green'];
